import React, { useEffect, useState } from 'react'
import { Button, Label } from 'semantic-ui-react'
import { useTalentApi } from '../../store/mainContext'

import { DataSelect } from '../form/form'
import TrEditButton from './trEditButton'
import TrCopyButton from './trCopyButton'

const TrDataSelect = ({
  name,
  label,
  placeholder,
  value,
  onSuccess,
  onBlur,
  url,
  render,
  dataCollection,
  multiple,
  search,
  divider,
  color,
  orderBy,
}) => {
  const api = useTalentApi()
  const [showEdit, setShowEdit] = useState(false)

  const [editMode, setEditMode] = useState(false)
  const [val, setVal] = useState(value)
  const [showAdd, setShowAdd] = useState(false)

  const [displayValue, setDisplayValue] = useState()

  const [isLoading, setIsLoading] = useState(false)

  const [, setCancelOnBlur] = useState(false)

  render = render || ((x) => x.text)

  const refreshDisplayValue = React.useCallback(
    async (newvalue) => {
      if (!newvalue) {
        setDisplayValue(null)
        return
      }

      if (Array.isArray(newvalue)) {
        const { data } = await api.get(dataCollection)

        setDisplayValue(
          (newvalue || []).map((v) =>
            render((data.filter((d) => d._id === v) || [])[0] || {})
          )
        )

        return
      }

      const { data } = await api.get(`${dataCollection}/${newvalue}`)
      setDisplayValue(render(data))
    },
    [api, dataCollection, render]
  )

  useEffect(() => {
    setVal(value)
    refreshDisplayValue(value)
  }, [value, refreshDisplayValue])

  const handleSave = async () => {
    if (val === value) {
      handleCancel()
      return
    }

    setCancelOnBlur(false)
    setIsLoading(true)

    const obj = {}
    obj[name] = val

    if (!val || val === '' || val.length === 0) {
      await api.delete(`${url}/${name}`)
    } else {
      await api.patch(url, obj)
    }

    await refreshDisplayValue(val)

    setIsLoading(false)
    setEditMode(false)
    onSuccess && onSuccess(name, val)
  }

  const handleCancel = () => {
    setCancelOnBlur(false)
    setVal(value)
    setEditMode(false)
    setIsLoading(false)
  }

  const handleKeyPress = (e) => {
    // const code = e.which;

    if (e.which === 13) handleSave()
  }

  if (editMode) {
    return (
      <tr
      // className="solidBackground"
      // onBlur={(x) => !cancelOnBlur && handleCancel()}
      >
        <th className={divider && 'solidBorderTop'}>{label}</th>
        <td
          className={divider && 'solidBorderTop'}
          style={{
            paddingTop: 4,
            textAlign: `right`,
          }}
        >
          <DataSelect
            name={name}
            disabled={isLoading}
            value={val}
            url={dataCollection}
            placeholder={placeholder}
            onKeyPress={handleKeyPress}
            onBlur={onBlur}
            onChange={(e, t) => setVal(t.value)}
            autoFocus={true}
            style={{ width: '100%' }}
            multiple={multiple}
            search={search}
            render={render}
            orderBy={orderBy}
          />

          <div style={{ marginTop: 10 }}>
            <Button
              content="Cancel"
              size="tiny"
              onClick={handleCancel}
              style={{ padding: `9px 13px` }}
              disabled={isLoading}
              onMouseOver={(x) => setCancelOnBlur(true)}
              onMouseOut={(x) => setCancelOnBlur(false)}
            />

            <Button
              color="black"
              content="Save"
              size="tiny"
              style={{ padding: `9px 20px`, marginRight: 0 }}
              onClick={handleSave}
              loading={isLoading}
              onMouseOver={(x) => setCancelOnBlur(true)}
              onMouseOut={(x) => setCancelOnBlur(false)}
            />
          </div>
        </td>
      </tr>
    )
  }

  if (!val || val === '') {
    return (
      <tr
        onClick={() => setEditMode(true)}
        onMouseEnter={() => setShowAdd(true)}
        onMouseLeave={() => setShowAdd(false)}
      >
        <th>{label}</th>
        <td>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>{showAdd && <a>+ Add value</a>}&nbsp;</a>
        </td>
      </tr>
    )
  }

  if (Array.isArray(displayValue)) {
    return (
      <tr
        onMouseEnter={() => setShowEdit(true)}
        onMouseLeave={() => setShowEdit(false)}
      >
        <th>{label}</th>
        <td style={{ position: 'relative' }}>
          {displayValue.map((dv) => (
            <Label
              key={dv}
              color={color}
              style={{ margin: 0, marginBottom: 7, marginRight: 5 }}
            >
              {dv}
            </Label>
          ))}

          <TrCopyButton visible={showEdit} value={displayValue.join(', ')} />
          <TrEditButton onClick={() => setEditMode(true)} visible={showEdit} />
        </td>
      </tr>
    )
  }

  return (
    <tr
      onMouseEnter={() => setShowEdit(true)}
      onMouseLeave={() => setShowEdit(false)}
    >
      <th>{label}</th>
      <td style={{ position: 'relative' }}>
        {displayValue}
        <TrCopyButton visible={showEdit} value={displayValue} />
        <TrEditButton onClick={() => setEditMode(true)} visible={showEdit} />
      </td>
    </tr>
  )
}

export default TrDataSelect
